import CommingSoonCountDown from "components/commingsoon-count-down";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { urlAssetsCustom } from "utils/common";
const TheBanner = () => {
  const navigate = useNavigate();
  

  const [scrollToElement, setScroolToElement] = useState(null);

  const handleScroll = (node) => {
    node.scrollIntoView({ behavior: "smooth" });
  };

  const location = useLocation();

  const handleScroolToElementAction = (elementId) => {
    if (location.pathname !== "/") {
      navigate("/");
      setScroolToElement(elementId);

      return;
    }
    handleScroll(document.getElementById(elementId));
  };

  useEffect(() => {
    !!scrollToElement && handleScroll(document.getElementById(scrollToElement));
    setScroolToElement(null);
  }, [scrollToElement]);

  return (
    <section className="banner">
      
     {(window.location.pathname === "/rule" || window.location.pathname === "/verifi-success") && (
    <div className="i-back" onClick={() => navigate("/")}></div>
)}
      
      {window.location.pathname === "/verifi-success" ?(<>
       <img
        className="img-full  d-none"
        src={urlAssetsCustom("assets/img/KV-success.png")}
        alt="line-bt"
      />
      </>):(<>
      <img
        className="img-full  d-none-mb"
        src={urlAssetsCustom("assets/img/KV.png")}
        alt="line-bt"
      />
      <img
        className="img-full  d-none"
        src={urlAssetsCustom("assets/img/KV.png")}
        alt="line-bt"
      />
        <div className="tab-menu">
        <div className="tab-home" onClick={() => navigate("/")}>
          {window.location.pathname === "/" ? (
          <img 
            className="img-full"
            src={urlAssetsCustom("assets/img/Tab-home-active.png")}
            alt="line-bt"
          />):( <img 
            className="img-full"
            src={urlAssetsCustom("assets/img/Tab-home.png")}
            alt="line-bt"
          />)}
        </div>
        <div className="tab-rule" onClick={() => navigate("/rule")}>
         
           {window.location.pathname === "/rule" ? (
          <img
            className="img-full"
            src={urlAssetsCustom("assets/img/Tab-rule-active.png")}
            alt="line-bt"
          />):( <img
            className="img-full"
            src={urlAssetsCustom("assets/img/Tab-rule.png")}
            alt="line-bt"
          />)}
        </div>
      </div>
      </>
      
      )}
    
      {/* {window.location.pathname !== "/prize" && (
        <div className="container">
          <div className="btn-wrapper">
            <button
              onClick={() => handleScroolToElementAction("form_join")}
              type="submit"
              className="btn btn-primary btn-block"
            >
              <a>THAM GIA NGAY</a>
            </button>
            <button
              onClick={() => handleScroolToElementAction("guide_join")}
              type="submit"
              className="btn btn-warning btn-block"
            >
              <a>hướng dẫn tham gia</a>
            </button>
            <button type="submit" className="btn btn-info btn-block">
              <a href="https://stsunlightbtaskee26qa.z23.web.core.windows.net//static">
                Not vietnam? Back to homepage
              </a>
            </button>
          </div>
        </div>
      )} */}
    </section>
  );
};

export default TheBanner;
